export class Counter {
  constructor(container) {
    this._container = container;
    this._counter = container.querySelector('.counter');
    this._pageCount = this._counter.querySelector('.counter__page');
    this._allCount = this._counter.querySelector('.counter__all');
  }

  getElem() {
    return this._counter;
  }

  update() {
    const count = Number(this._pageCount.textContent);
    if (count > 0) {
      this._show();
    } else {
      this._hide();
    }
  }

  _show() {
    this._counter.classList.remove('hide');
  }

  _hide() {
    this._counter.classList.add('hide');
  }

}
